module.exports = __webpack_public_path__ + "img/main-leaf.e61eaf29.svg";